<div style="width: 100%">
	<form [formGroup]="carrierCtrl" class="example-form">
		<mat-form-field style="width: 100%">
			<mat-chip-list #chipList>
				<mat-chip
					*ngIf="carrierSelected != undefined && carrierSelected != null && !isCarrierSearchEnabled"
				>
					{{
						!utilService.isNullOrUndefined(carrierSelected.businessName)
							? carrierSelected.businessName
							: ''
					}}
					<mat-icon (click)="enableSearch()" class="primary-light-color" matChipRemove
						>cancel</mat-icon
					>
				</mat-chip>

				<input
					#carrierInput
					(matChipInputTokenEnd)="add($event)"
					[disabled]="!isCarrierSearchEnabled"
					[formControl]="carrierCtrl"
					[matAutocomplete]="auto"
					[matChipInputAddOnBlur]="addOnBlur"
					[matChipInputFor]="chipList"
					[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
					placeholder="Search by carrier name"
				/>
			</mat-chip-list>

			<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
				<mat-option *ngIf="isLoading" fxLayoutAlign="center center">
					<mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
				</mat-option>

				<ng-container *ngIf="!isLoading">
					<mat-option *ngFor="let carrier of listOfCarriers" [value]="carrier.businessName">
						{{ carrier.businessName }}
						<span *ngIf="!utilService.isNullOrUndefined(carrier.mc)" class="font-size-7-vw">
							MC/MX: {{ carrier.mc }}</span
						>
						<span *ngIf="!utilService.isNullOrUndefined(carrier.dot)" class="font-size-7-vw">
							DOT: {{ carrier.dot }}</span
						>
					</mat-option>
				</ng-container>
			</mat-autocomplete>
		</mat-form-field>
	</form>
</div>
